export default __webpack_public_path__ + "static/media/partner_logo_strim.23943365.svg";